import React, { Dispatch, SetStateAction } from "react";
import LinearSelector from "../token/LinearSelector";
import { useSearchParams } from "react-router-dom";

// Updated union type to include Brands and Studios
export type TypeOption = string;

interface DiscoverFiltersProps {
  selectedType: TypeOption;
  setSelectedType: Dispatch<SetStateAction<TypeOption>>;
}

const DiscoverFilters: React.FC<DiscoverFiltersProps> = ({
  selectedType,
  setSelectedType,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <LinearSelector
      // Options now include Brands and Studios.
      options={
        ["Dashboard", "Ventes", "Analyses"] as TypeOption[] //, "Bénéfices"
      }
      selected={selectedType}
      setSelected={setSelectedType}
      onSelect={(option) => {
        // Handle navigation based params
        setSearchParams((prev) => {
          const newParams = new URLSearchParams(prev);
          newParams.set("type", option);
          return newParams;
        });
        setSelectedType(option);
      }}
    />
  );
};

export default DiscoverFilters;
